import React, { useEffect } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { RootState } from 'redux/schemas';

import { RolePlayInteractionMode } from 'redux/schemas/models/ai-role-play';
import { getFlatCourseAliases } from 'redux/selectors/course';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import AvatarList from './avatar-list';

const AICharacterVoice = () => {
  const { setValue, watch } = useFormContext();
  const interactionMode = watch('interactionMode');
  const params = useLecturePageParams();
  const courseAliases = useSelector((state: RootState) => getFlatCourseAliases(state, params.catalogId));

  useEffect(() => {
    if (interactionMode !== RolePlayInteractionMode.VIDEO) {
      setValue('interactionMode', RolePlayInteractionMode.VIDEO, { shouldDirty: true });
    }
  }, [interactionMode, setValue]);

  return (
    <div className='mt-6'>
      <div className='bold text-large-body lh-25'>
        {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.AI_VIDEO.TITLE()}
      </div>
      <div className='mt-1 text-gray-1 text-large-body lh-25'>
        {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.AI_VIDEO.DESCRIPTION(courseAliases)}
      </div>

      <AvatarList />
    </div>
  );
};

export default AICharacterVoice;
